import React from 'react';
import startCase from 'lodash/startCase';
import classNames from 'classnames';
import pt from 'prop-types';
import Icon from 'components/icon/icon';
import './color-scheme-group.scss';

function SwellColorSchemePreview({
  schemeId,
  settings,
  className,
  onSchemeClick,
}) {
  const editable = typeof onSchemeClick === 'function';
  const Tag = editable ? 'button' : 'div';

  const elemProps = React.useMemo(
    /** @returns {React.HTMLAttributes<HTMLButtonElement>} */
    () => {
      if (onSchemeClick) {
        return {
          'data-id': schemeId,
          onClick: onSchemeClick,
          type: 'button',
        };
      }

      return {};
    },
    [schemeId, onSchemeClick],
  );

  return (
    <Tag
      className={classNames(
        'storefront-editor--color-scheme--preview',
        className,
      )}
      style={{
        color: settings.text,
        backgroundColor: settings.background,
      }}
      {...elemProps}
    >
      {editable && (
        <div className="storefront-editor--color-scheme--preview-overlay">
          <Icon fa="pencil" />
        </div>
      )}
      <div className="storefront-editor--color-scheme--preview-name">
        {settings.label || startCase(schemeId)}
      </div>

      <div className="storefront-editor--color-scheme--preview-flex">
        <div className="storefront-editor--color-scheme--preview-text">Aa</div>

        <div className="storefront-editor--color-scheme--preview-flex">
          <div
            className="storefront-editor--color-scheme--preview-button"
            style={{
              color: settings.button_label,
              backgroundColor: settings.button,
              borderColor: settings.button,
            }}
          >
            Aa
          </div>

          <div
            className="storefront-editor--color-scheme--preview-button"
            style={{
              color: settings.secondary_button_label,
              backgroundColor: 'transparent',
              borderColor: settings.secondary_button_label,
            }}
          >
            Aa
          </div>
        </div>
      </div>
    </Tag>
  );
}

SwellColorSchemePreview.propTypes = {
  schemeId: pt.string.isRequired,
  className: pt.string,

  settings: pt.shape({
    label: pt.string,
    text: pt.string,
    background: pt.string,
    button_label: pt.string,
    button: pt.string,
    secondary_button_label: pt.string,
  }).isRequired,

  onSchemeClick: pt.func,
};

export default React.memo(SwellColorSchemePreview);
